<template>
    <b-modal
        size="lg"
        ref="modal"
        hide-footer
        :busy="false"
        button-size="sm"
        :no-close-on-esc="false"
        :no-close-on-backdrop="false"
        :title="$t('people.changeUsersStage')"
        @hidden="routerBack"
        @cancel="routerBack"
    >
        <stages-administration
            :data="stages"
            :selectedUsers="usersToAPI"
            :canChangeUsersStage="canChangeUsersStage"
            @updated="onUpdateUsersStage"
        />
    </b-modal>
</template>

<script>
import { getStagesFromApi } from './api'
import {
    noSelectedUsersAlert,
    onlyAdministratorFunctionAlert,
} from '../../alerts'
import StagesAdministration from '@/views/components/stages-administration/change-users-stage'

export default {
    name: 'UsersStagesAdministration',
    components: {
        StagesAdministration,
    },
    props: {
        users: {
            type: Array,
            default: () => [],
        },
        canChangeUsersStage: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            stages: [],
            isLoading: false,
        }
    },
    mounted() {
        if (!this.canChangeUsersStage) {
            this.handlerUserWithoutAuthorization()
            return
        }

        if (!this.users.length) {
            this.handlerNoUsersSelecteds()
            return
        }

        this.$refs.modal.show()
        this.getStages()
    },
    methods: {
        routerBack() {
            this.$router.back(-1)
        },
        onUpdateUsersStage() {
            this.$emit('updated')
            this.routerBack()
        },
        handlerUserWithoutAuthorization() {
            this.$refs.modal.hide()
            return onlyAdministratorFunctionAlert().then(() =>
                this.routerBack()
            )
        },
        handlerNoUsersSelecteds() {
            return noSelectedUsersAlert().then(() => this.routerBack())
        },
        getStages() {
            this.isLoading = true
            getStagesFromApi()
                .then(stages => {
                    this.stages = stages
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
    computed: {
        usersToAPI() {
            return this.users.map(id => {
                return {
                    id,
                }
            })
        },
    },
}
</script>
